<template>
  <div class="privacy-page">
    <div class="privacy-card">
      <h1 class="privacy-title">隐私政策</h1>
      
      <div class="privacy-content">
        <section class="section">
          <h2 class="section-title">引言</h2>
          <p class="section-text">
            甜筒星球（以下简称"我们"）非常重视用户的隐私和个人信息保护。
            本隐私政策旨在向您说明我们如何收集、使用、存储和保护您的个人信息。
            请您在使用我们的服务前，仔细阅读并了解本隐私政策。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">一、我们收集的信息</h2>
          <p class="section-text">
            1. 您主动提供的信息：
          </p>
          <ul class="list">
            <li>注册信息：昵称、头像、手机号码等；</li>
            <li>个人资料：性别、生日、个人简介等；</li>
            <li>直播内容：视频、音频、弹幕、评论等；</li>
            <li>交易信息：充值记录、消费记录等。</li>
          </ul>
          <p class="section-text">
            2. 我们自动收集的信息：
          </p>
          <ul class="list">
            <li>设备信息：设备型号、操作系统版本、设备标识符等；</li>
            <li>日志信息：IP地址、访问时间、浏览记录等；</li>
            <li>位置信息：经您授权后获取的地理位置信息。</li>
          </ul>
        </section>

        <section class="section">
          <h2 class="section-title">二、我们如何使用信息</h2>
          <p class="section-text">
            我们使用您的信息主要用于以下目的：
          </p>
          <ul class="list">
            <li>为您提供直播、社交、内容发布等服务；</li>
            <li>进行用户身份验证和账号安全保护；</li>
            <li>向您推荐您可能感兴趣的内容和用户；</li>
            <li>处理您的充值、提现等交易请求；</li>
            <li>改进我们的产品和服务质量；</li>
            <li>遵守法律法规和监管要求。</li>
          </ul>
        </section>

        <section class="section">
          <h2 class="section-title">三、信息的共享与披露</h2>
          <p class="section-text">
            我们不会将您的个人信息出售给第三方。但在以下情况下，我们可能会共享或披露您的信息：
          </p>
          <ul class="list">
            <li>获得您的明确同意；</li>
            <li>与我们的关联公司共享，以提供更好的服务；</li>
            <li>与第三方服务提供商共享，用于技术支持和业务运营；</li>
            <li>根据法律法规、法院命令或政府要求；</li>
            <li>为了保护我们或他人的合法权益。</li>
          </ul>
        </section>

        <section class="section">
          <h2 class="section-title">四、信息的存储与保护</h2>
          <p class="section-text">
            1. 信息存储：我们将您的个人信息存储在中华人民共和国境内，
            并采取合理的安全措施保护您的信息安全。
          </p>
          <p class="section-text">
            2. 安全措施：我们使用加密技术、访问控制、安全审计等技术手段，
            防止您的个人信息被未经授权的访问、使用或泄露。
          </p>
          <p class="section-text">
            3. 信息保留：我们只会在必要的时间内保留您的个人信息，
            超出保留期限后，我们会对您的信息进行删除或匿名化处理。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">五、您的权利</h2>
          <p class="section-text">
            根据相关法律法规，您对自己的个人信息享有以下权利：
          </p>
          <ul class="list">
            <li>访问权：您有权查看我们持有的您的个人信息；</li>
            <li>更正权：您有权更正不准确的个人信息；</li>
            <li>删除权：您有权要求删除您的个人信息；</li>
            <li>撤回同意权：您有权撤回之前给予的授权；</li>
            <li>注销账号权：您有权申请注销您的账号。</li>
          </ul>
        </section>

        <section class="section">
          <h2 class="section-title">六、Cookie和类似技术</h2>
          <p class="section-text">
            我们使用Cookie和类似技术来收集和存储有关您的信息，
            以便为您提供更好的服务体验。您可以通过浏览器设置管理Cookie偏好。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">七、未成年人保护</h2>
          <p class="section-text">
            我们非常重视未成年人的个人信息保护。如果您未满18周岁，
            请在监护人的指导下使用我们的服务。我们不会故意收集未成年人的个人信息，
            除非获得监护人的同意。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">八、隐私政策的更新</h2>
          <p class="section-text">
            我们可能会不时更新本隐私政策。更新后的政策将在平台上公布，
            重大变更我们会通过适当方式通知您。建议您定期查看本隐私政策。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">九、联系我们</h2>
          <p class="section-text">
            如果您对本隐私政策有任何疑问或建议，或需要行使您的权利，
            请通过以下方式联系我们：
          </p>
          <p class="section-text">
            客服邮箱：support@tiantong.com
          </p>
          <p class="section-text">
            客服电话：400-123-4567
          </p>
        </section>
      </div>

      <div class="privacy-footer">
        <p class="update-time">更新时间：2024年1月1日</p>
        <button class="btn-accept" @click="acceptPrivacy">我已阅读并同意</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPage',
  methods: {
    acceptPrivacy() {
      this.$emit('accept')
      this.$message.success('已同意隐私政策')
    }
  }
}
</script>

<style scoped lang="scss">
// 页面容器
.privacy-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 24px;
}

// 隐私政策卡片
.privacy-card {
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  padding: 40px;
}

// 标题
.privacy-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin: 0 0 32px 0;
}

// 内容区域
.privacy-content {
  margin-bottom: 32px;
}

// 章节
.section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0 0 12px 0;
  }

  .section-text {
    font-size: 14px;
    color: #666;
    line-height: 1.8;
    margin: 0 0 8px 0;
    text-align: justify;
  }

  .list {
    margin: 8px 0;
    padding-left: 24px;

    li {
      font-size: 14px;
      color: #666;
      line-height: 1.8;
      margin-bottom: 4px;
    }
  }
}

// 底部区域
.privacy-footer {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #e8e8e8;

  .update-time {
    font-size: 13px;
    color: #999;
    margin: 0 0 16px 0;
  }

  .btn-accept {
    padding: 12px 48px;
    background: #8B5CF6;
    border: none;
    border-radius: 24px;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>